import React, { Component } from "react";
import {
  Box, Typography, Button, TextField,
  Table, TableBody, TableCell, TableHead,
  TableRow, TableContainer, Paper, CircularProgress, Snackbar, Alert,
} from "@mui/material";

import { createTheme, ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";

import urls from "../../custom_libraries/urls";
import globalVariables from "../../custom_libraries/globalVariables";
import { get } from "../../custom_libraries/serverRequests";

// ✅ SAME DARK THEME AS CapacityDashboard
const darkTheme = createTheme({
  palette: {
    mode: "dark",
    background: {
      default: "#191e29",
      paper: "#2c3342",
    },
    text: {
      primary: "#ffffff",
      secondary: "#bbbbbb",
    },
  },
});

class PagingSession extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sessions: [],
      loading: false,
      session_error: false,
      response_message: ""
    };
  }

  componentDidMount() {
    this.fetchSessions();
  }

  componentDidUpdate(prevProps, prevState) {
    if (
        this.state.session_error !== prevState.session_error
    ){
       if (
            this.state.session_error 
             ) {
            setTimeout(() => {
                this.setState({
                    session_error: false

    });
            }, 3000); // 3 second
        }
    }
}

  fetchSessions = async () => {
    try {
      this.setState({ loading: true });

      let token = localStorage.getItem(globalVariables.AUTH_TOKEN);
      let user_id = localStorage.getItem("user_id");

      if (!user_id) {
        console.error("User ID not found in localStorage");
        this.setState({ loading: false });
        return;
      }

      let headers = {
        "content-type": "application/json",
        Authorization: `Bearer ${token}`,
      };

      const response = await get(
        urls.GET_PAGING_DEVICE_SESSION(user_id),
        headers
      );

      this.setState({
        sessions: Array.isArray(response) ? response : [],
        loading: false,
      });

    } catch (err) {
      console.error("GET Error:", err);
      this.setState({ loading: false });
    }
  };

  createSession = async () => {
    try {
      const { sessionInput } = this.state;

      if (!sessionInput) {
        alert("Enter Session UUID");
        return;
      }

      let token = localStorage.getItem(globalVariables.AUTH_TOKEN);

      const res = await fetch(urls.PAGING_DEVICE_SESSION, {
        method: "POST",
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          paging_device_session: sessionInput,
        }),
      });

      const data = await res.json();

      if (!res.ok) {
        if(data.error)
      {
        // this.openSnackbar(data.error, "error");
        this.setState({session_error: true, response_message: data.error})
        return;
      } else{
        console.error("POST Failed:", data);
        // alert("Failed to create session");
        this.setState({session_error: true, response_message: "Failed to create session"})
        return;
      }
      }
      

      this.setState({ sessionInput: "" }, () => {
        this.fetchSessions();
      });

    } catch (err) {
      console.error("POST Error:", err);
    }
  };


  render() {
    const { sessions, loading, sessionInput, session_error, response_message } = this.state;

    return (
      <ThemeProvider theme={darkTheme}>
        <CssBaseline />

        <Box
        sx={{
            p: 3,
            pt: 0,
            pl: 8,   // ✅ adds space from left
            background: "#191e29",
            minHeight: "100vh",
            width: "100%",
            minWidth: 0,
            "@media (max-width: 768px)": {
              p: "15px",
              pt: 0,
              marginLeft: "18px"
            },
        }}
        >
          <Box
            sx={{
              minHeight: "48px",
              "@media (max-width: 768px)": {
                minHeight: "auto",
                mb: 1,
              },
              // mb: 1
            }}
          >
            <Alert
              severity="error"
              sx={{
                visibility: session_error ? "visible" : "hidden",
                overflowWrap: "anywhere",
              }}
            >
              {response_message || " "}
            </Alert>
          </Box>
          <Typography variant="h6" sx={{ mt: 1, mb:2, color: "#fff" }}>
            Paging Device Sessions
          </Typography>

          
          {/* INPUT */}
          <Box
            sx={{
              display: "flex",
              gap: 2,
              mb: 3,
              "@media (max-width: 768px)": {
                flexDirection: "column",
                gap: 1.5,
              },
            }}
          >
            <TextField
              label="Session UUID"
              size="small"
              value={sessionInput}
              onChange={(e) =>
                this.setState({ sessionInput: e.target.value })
              }
              sx={{
                backgroundColor: "#3c4456",
                borderRadius: 1,
                width: 300,
                input: { color: "#fff" },
                label: { color: "#bbb" },
                "@media (max-width: 768px)": {
                  width: "100%",
                },
              }}
            />

            <Button
              variant="contained"
              onClick={this.createSession}
              sx={{
                "@media (max-width: 768px)": {
                  width: "100%",
                  minHeight: 40,
                },
              }}
            >
              Create/Update
            </Button>
          </Box>

          {/* LOADER */}
          {loading && <CircularProgress />}

          {/* TABLE */}
          <TableContainer
            component={Paper}
            sx={{
              backgroundColor: "#2c3342",
              maxWidth: "100%",
              overflowX: "auto",
              WebkitOverflowScrolling: "touch",
            }}
          >
            <Table
              sx={{
                "@media (max-width: 768px)": {
                  minWidth: 600,
                },
              }}
            >
              <TableHead>
                <TableRow sx={{ backgroundColor: "#222b3f" }}>
                  <TableCell sx={{ color: "#fff" }}>Session UUID</TableCell>
                  <TableCell sx={{ color: "#fff" }}>User</TableCell>
                  <TableCell sx={{ color: "#fff" }}>Created At</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {sessions.length > 0 ? (
                  sessions.map((item) => (
                    <TableRow key={item.id}>
                      <TableCell sx={{ color: "#fff" }}>
                        {item.paging_device_session}
                      </TableCell>
                      <TableCell>
                        {localStorage.getItem(globalVariables.USER_NAME) || item.user}
                        </TableCell>
                      <TableCell sx={{ color: "#fff" }}>
                        {item.created_at}
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  !loading && (
                    <TableRow>
                      <TableCell colSpan={4} align="center" sx={{ color: "#fff" }}>
                        No Sessions Found
                      </TableCell>
                    </TableRow>
                  )
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </ThemeProvider>
    );
  }
}

export default PagingSession;
